var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPricinginline = function SvgPricinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0E0F",
    d: "M8.002 1.814a1.2 1.2 0 0 1 1.74-.246l2.616 2.124a1.2 1.2 0 0 1 .235 1.608h-.976l.312-.447a.4.4 0 0 0-.075-.54L10.506 3.22 9.07 5.3h-.974l1.787-2.585-.646-.525a.4.4 0 0 0-.58.081L6.544 5.3h-.976l2.434-3.485ZM10.8 10.1a.4.4 0 1 0 0 .8h.8a.4.4 0 0 0 0-.8h-.8ZM3.6 4.5h1.735l-.56.8H3.6a.4.4 0 0 0 0 .8H12a1.6 1.6 0 0 1 1.6 1.6v4.8a1.6 1.6 0 0 1-1.6 1.6H4.4a2 2 0 0 1-2-2V5.7a1.2 1.2 0 0 1 1.2-1.2Zm-.4 7.6a1.2 1.2 0 0 0 1.2 1.2H12a.8.8 0 0 0 .8-.8V7.7a.8.8 0 0 0-.8-.8H3.6c-.14 0-.275-.024-.4-.068V12.1Z"
  })));
};
export default SvgPricinginline;